import React from "react";
import { Link } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import { Footer } from './headerFooter';
import "./custom.scss";

const TermsOfUse = () => {
  return (
    <div id="root">
      <main className='main-container'>
        <Container className='custom-container pt-3'>
            <h2>Όροι Χρήσης</h2>
            <p>Τελευταία ενημέρωση: 8 Ιουνίου 2026</p>

            <h3>1. Περιγραφή Υπηρεσίας</h3>
            <p>
              Η εφαρμογή <strong>teachers-app.com</strong> είναι μια{" "}
              <strong>πιλοτική, ενημερωτική</strong> διαδικτυακή υπηρεσία που απευθύνεται σε{" "}
              <strong>αναπληρωτές και μόνιμους εκπαιδευτικούς όλων των ειδικοτήτων</strong>.
              Παρέχει εργαλεία αναζήτησης, στατιστικής ανάλυσης και οπτικοποίησης δεδομένων
              σχετικά με προσλήψεις, πίνακες κατάταξης, μεταθέσεις, μοριοδότηση σχολικών μονάδων
              και άλλες πληροφορίες χρήσιμες για εκπαιδευτικούς.
            </p>
            <p>
              Τα περισσότερα δεδομένα προέρχονται από δημόσιες ανακοινώσεις του{" "}
              <strong>Υπουργείου Παιδείας, Θρησκευμάτων και Αθλητισμού</strong> (minedu.gov.gr).
              Η πρόσβαση στις λειτουργίες της εφαρμογής απαιτεί{" "}
              <strong>εγγραφή και σύνδεση</strong> με προσωπικό λογαριασμό.
            </p>

            <h3>2. Προέλευση και Χρήση Δεδομένων</h3>
            <p>
              Η εφαρμογή χρησιμοποιεί δημόσια προσβάσιμα δεδομένα από τις ακόλουθες πηγές:
            </p>
            <ul>
              <li>
                <strong>Υπουργείο Παιδείας, Θρησκευμάτων και Αθλητισμού</strong> — επίσημες
                ανακοινώσεις, πίνακες προσλήψεων και διορισμών, ιστορικά στοιχεία τοποθετήσεων
                και σχετικά έγγραφα (minedu.gov.gr).
              </li>
              <li>
                <strong>spitogatos.gr</strong> — ενδεικτικοί μέσοι όροι τιμών ενοικίων ανά περιοχή,
                για τη σελίδα «Τιμές ενοικίων». Δεν υφίσταται εμπορική ή συνεργατική σχέση με τον
                ιστότοπο αυτόν.
              </li>
            </ul>
            <p>
              Τα πρωτογενή δημόσια δεδομένα <strong>δεν τροποποιούνται στη πηγή τους</strong>.
              Η εφαρμογή τα <strong>συλλέγει, οργανώνει, υπολογίζει και παρουσιάζει</strong> με
              σκοπό να διευκολύνει την κατανόηση και την πρόσβαση των χρηστών. Τα παράγωγα
              αποτελέσματα (στατιστικά, εκτιμήσεις, ομαδοποιήσεις){" "}
              <strong>δεν αποτελούν επίσημες ανακοινώσεις</strong> του Υπουργείου Παιδείας ή
              άλλου δημόσιου φορέα.
            </p>
            <p>
              Όπου ισχύουν, τα δημόσια δεδομένα του Υπουργείου Παιδείας χρησιμοποιούνται κατά
              τρόπο συμβατό με τους όρους ανοικτών δεδομένων (Open Data) του ελληνικού δημοσίου.
              Οι πηγές τρίτων (π.χ. spitogatos.gr) δεν υπόκεινται απαραίτητα στο ίδιο πλαίσιο.
            </p>

            <h3>3. Φύση Υπηρεσίας και Μη Σύνδεση με Δημόσιους Φορείς</h3>
            <p>
              Η εφαρμογή <strong>δεν</strong> αποτελεί επίσημη υπηρεσία του Υπουργείου Παιδείας,
              του ΑΣΕΠ ή οποιουδήποτε άλλου δημόσιου φορέα. Δεν εκπροσωπεί, δεν συνδέεται και
              δεν εγκρίνεται από αυτούς.
            </p>
            <p>
              Η εφαρμογή <strong>δεν παρέχει νομική, διοικητική ή επαγγελματική συμβουλή</strong>.
              Οι πληροφορίες που παρουσιάζονται έχουν αποκλειστικά{" "}
              <strong>ενημερωτικό χαρακτήρα</strong>. Για κρίσιμες αποφάσεις, οι χρήστες οφείλουν
              να επαληθεύουν τις πληροφορίες στην επίσημη πηγή (Υπουργείο Παιδείας, ΑΣΕΠ κ.λπ.).
            </p>
            <p>
              Η εφαρμογή <strong>δεν προβλέπει μελλοντικές προσλήψεις</strong>, αλλά βασίζεται
              αποκλειστικά σε ιστορικά δεδομένα προηγούμενων σχολικών ετών, όπου αυτό ισχύει.
            </p>

            <h3>4. Στατιστικές Εκτιμήσεις και Εργαλείο «Εκτιμήσεις Πιθανοτήτων Πρόσληψης» (BETA)</h3>
            <p>
              Το εργαλείο «Εκτιμήσεις πιθανοτήτων πρόσληψης» αναλύει{" "}
              <strong>ιστορικά δεδομένα</strong> προηγούμενων ετών (τοποθετήσεις ανά περιοχή) και
              τα συγκρίνει με τη <strong>θέση κατάταξης</strong> που δηλώνει ο χρήστης. Τα
              αποτελέσματα είναι <strong>στατιστική εκτίμηση</strong> για ενημερωτική χρήση και{" "}
              <strong>δεν αποτελούν εγγύηση</strong> πρόσληψης ή τοποθέτησης.
            </p>
            <ul>
              <li>
                Τα ποσοστά πιθανότητας βασίζονται σε ιστορικά μοτίβα και{" "}
                <strong>δεν προβλέπουν</strong> μελλοντικές προσλήψεις.
              </li>
              <li>
                Η σειρά προτίμησης των περιοχών <strong>δεν επηρεάζει</strong> τους υπολογισμούς.
              </li>
              <li>
                Η λειτουργία βρίσκεται σε <strong>δοκιμαστική έκδοση (BETA)</strong>: μπορεί να
                αλλάξει, να περιοριστεί, να βελτιωθεί ή να αποσυρθεί χωρίς προειδοποίηση.
              </li>
            </ul>

            <h3>5. Λογαριασμοί Χρηστών και Αποδεκτή Χρήση</h3>
            <p>
              Η χρήση της εφαρμογής απαιτεί εγγραφή με έγκυρα στοιχεία. Ο χρήστης είναι
              υπεύθυνος για τη <strong>ασφάλεια των στοιχείων πρόσβασης</strong> του λογαριασμού
              του και για κάθε δραστηριότητα που πραγματοποιείται μέσω αυτού.
            </p>
            <p>Απαγορεύεται ρητά:</p>
            <ul>
              <li>Η αυτοματοποιημένη, μαζική ή κακόβουλη χρήση της εφαρμογής (scraping, bots, κατάχρηση API).</li>
              <li>Η προσπάθεια παρέμβασης στη λειτουργία ή την ασφάλεια της υπηρεσίας.</li>
              <li>Η χρήση της εφαρμογής για παράνομους ή μη εξουσιοδοτημένους σκοπούς.</li>
            </ul>
            <p>
              Η ομάδα του teachers-app.com διατηρεί το δικαίωμα{" "}
              <strong>αναστολής ή διακοπής</strong> λογαριασμού σε περίπτωση κατάχρησης, χωρίς
              προηγούμενη ειδοποίηση όπου το επιβάλλει η ασφάλεια της υπηρεσίας.
            </p>
            <p>
              Για τη συλλογή και επεξεργασία προσωπικών δεδομένων, ισχύει η{" "}
              <Link to="/privacy-policy" className="footer-links">
                Πολιτική Απορρήτου
              </Link>.
            </p>

            <h3>6. Εθελοντική Στήριξη και Premium Πρόσβαση (PayPal)</h3>
            <p>
              Η εφαρμογή προσφέρει τη δυνατότητα <strong>εθελοντικής χορηγίας</strong> μέσω{" "}
              <strong>PayPal</strong>, με σκοπό τη στήριξη της λειτουργίας και ανάπτυξης του
              project. Η χορηγία <strong>δεν αποτελεί αγορά</strong> αποτελέσματος, πρόσληψης ή
              οποιασδήποτε υπηρεσίας με εγγυημένο αποτέλεσμα.
            </p>
            <ul>
              <li>
                Η χορηγία μπορεί να ξεκλειδώσει <strong>απεριόριστη πρόσβαση</strong> στο
                εργαλείο «Εκτιμήσεις πιθανοτήτων πρόσληψης» (premium). Οι μη premium χρήστες
                έχουν δικαίωμα σε <strong>3 δωρεάν προσπάθειες</strong> χρήσης του εργαλείου.
              </li>
              <li>
                Οι πληρωμές επεξεργάζονται αποκλειστικά από την <strong>PayPal</strong>. Η
                εφαρμογή <strong>δεν αποθηκεύει</strong> στοιχεία πληρωμής (π.χ. αριθμούς καρτών).
              </li>
              <li>
                <strong>Δεν εγγυόμαστε</strong> μόνιμη διαθεσιμότητα premium πρόσβασης· το
                μοντέλο μπορεί να τροποποιηθεί με ενημέρωση των παρόντων όρων.
              </li>
              <li>
                Για θέματα επιστροφής χρημάτων, ισχύουν οι πολιτικές της PayPal. Μπορείτε να
                επικοινωνήσετε μαζί μας στο{" "}
                <a href="mailto:support@teachers-app.com">support@teachers-app.com</a>.
              </li>
            </ul>

            <h3>7. Περιορισμός Ευθύνης</h3>
            <p>
              Η ομάδα του <strong>teachers-app.com</strong> καταβάλλει κάθε δυνατή προσπάθεια
              για την παροχή ακριβούς και έγκυρης πληροφόρησης. Παρ' όλα αυτά:
            </p>
            <ul>
              <li>Δεν εγγυάται την πληρότητα, ακρίβεια ή επικαιρότητα των πληροφοριών.</li>
              <li>Δεν φέρει ευθύνη για τυχόν λάθη, παραλείψεις ή παρερμηνείες των δεδομένων.</li>
              <li>
                Δεν φέρει ευθύνη για διαφορές μεταξύ <strong>προσωρινών και εκκαθαρισμένων</strong>{" "}
                πινάκων (π.χ. ΑΣΕΠ) ή για καθυστερήσεις ενημέρωσης δεδομένων.
              </li>
              <li>
                Δεν φέρει ευθύνη για αποτελέσματα <strong>στατιστικών εκτιμήσεων</strong>,
                εκτιμήσεων ημερομηνίας πρόσληψης, αριθμών ατόμων που προηγούνται ή άλλων
                παράγωγων υπολογισμών — ιδίως για λειτουργίες σε <strong>δοκιμαστική έκδοση (BETA)</strong>.
              </li>
              <li>
                Δεν φέρει ευθύνη για ανακρίβειες ή αλλαγές σε δεδομένα τρίτων (π.χ. spitogatos.gr).
              </li>
              <li>
                Οι χρήστες φέρουν την αποκλειστική ευθύνη για οποιαδήποτε απόφαση ή ενέργεια
                βασισμένη στις πληροφορίες που παρέχονται από την εφαρμογή.
              </li>
            </ul>
            <p>
              Για επίσημες αποφάσεις, οι χρήστες καλούνται να ανατρέχουν στην{" "}
              <strong>επίσημη ιστοσελίδα του Υπουργείου Παιδείας</strong> και στις αντίστοιχες
              επίσημες πηγές.
            </p>

            <h3>8. Πνευματικά Δικαιώματα</h3>
            <p>
              Το περιεχόμενο της εφαρμογής (π.χ. σχεδίαση, κώδικας, οργάνωση πληροφοριών), με
              εξαίρεση τα δημόσια δεδομένα, αποτελεί{" "}
              <strong>πνευματική ιδιοκτησία της ομάδας ανάπτυξης του teachers-app.com</strong>.
            </p>
            <p>
              Απαγορεύεται η αντιγραφή, αναπαραγωγή, τροποποίηση ή εμπορική εκμετάλλευση
              οποιουδήποτε μέρους της εφαρμογής χωρίς προηγούμενη γραπτή άδεια.
            </p>

            <h3>9. Τρίτες Υπηρεσίες</h3>
            <p>
              Η εφαρμογή ενδέχεται να χρησιμοποιεί ή να συνδέεται με υπηρεσίες τρίτων, όπως:
            </p>
            <ul>
              <li><strong>PayPal</strong> — επεξεργασία εθελοντικών χορηγιών.</li>
              <li><strong>Namecheap</strong> — φιλοξενία (hosting) της εφαρμογής.</li>
            </ul>
            <p>
              Η ομάδα του teachers-app.com δεν φέρει ευθύνη για διακοπές, αλλαγές πολιτικής ή
              τεχνικά προβλήματα που οφείλονται σε τρίτους παρόχους. Η χρήση των υπηρεσιών
              αυτών υπόκειται στους δικούς τους όρους.
            </p>

            <h3>10. Αλλαγές στους Όρους</h3>
            <p>
              Οι παρόντες Όροι Χρήσης ενδέχεται να τροποποιούνται. Για{" "}
              <strong>ουσιώδεις αλλαγές</strong> (π.χ. όσες αφορούν πληρωμές, premium πρόσβαση ή
              επεξεργασία δεδομένων), θα καταβάλλεται προσπάθεια εύλογης ειδοποίησης (π.χ. μέσω
              της εφαρμογής ή email, όπου εφικτό) πριν από την έναρξη ισχύος τους.
            </p>
            <p>
              Οι χρήστες οφείλουν να ελέγχουν περιοδικά αυτή τη σελίδα για τυχόν αλλαγές.
              Η ημερομηνία «τελευταίας ενημέρωσης» ανανεώνεται κάθε φορά που τροποποιούνται οι όροι.
              Η συνέχιση της χρήσης της εφαρμογής μετά από τροποποίηση συνιστά αποδοχή των
              ενημερωμένων όρων.
            </p>


            <h3>11. Επικοινωνία</h3>
            <p>
              Για οποιαδήποτε ερώτηση, απορία ή αίτημα σχετικό με τους Όρους Χρήσης, μπορείτε
              να επικοινωνήσετε μαζί μας στο:{" "}
              <strong><a href="mailto:support@teachers-app.com">support@teachers-app.com</a></strong>
            </p>
        </Container>
      </main>
    <Footer />
    </div>
  );
};


export default TermsOfUse;
